import { Question } from '../../question.class';
import { findLast } from 'lodash';

export function removeEmptyNumberOptions(question: Question, type = 'number') {
  let empty_count = question.options.filter(o => o.type === type && !o.text)
    .length;
  let all_count = question.options.filter(o => o.type === type).length;

  let delete_cnt = 0;
  while (empty_count > 0 && all_count > 2) {
    let emptyOption = findLast(
      question.options,
      o => o.type === type && !o.text
    );
    question.deleteOptions({ id: emptyOption.id }, { push: 'none' });
    empty_count--;
    all_count--;
    delete_cnt++;
  }
  if (delete_cnt) question.notifyChangeThruTree([]);
}
